/**
 * Device Agent permission keys (catalog `device.*`, docs/contracts/device-agent.md §6). Pairing and revoking agents,
 * editing device profiles and managing jobs are separate duties (ADR-0014/D-5); the API checks the same keys.
 */
export const devicePermissions = {
  agentView: "device.agent.view",
  agentPair: "device.agent.pair",
  agentRevoke: "device.agent.revoke",
  profileView: "device.device_profile.view",
  profileUpdate: "device.device_profile.update",
  jobView: "device.device_job.view",
  jobCreate: "device.device_job.create",
  jobManage: "device.device_job.manage",
  releaseView: "device.agent_release.view",
  releaseUpdate: "device.agent_release.update",
  scanView: "device.scan.view",
  scanCreate: "device.scan.create",
} as const;

/** The device settings group (`/platform/settings/devices`). */
export const deviceSettingsGroup = "devices";

/** Plan module of the device screens (part of the platform). */
export const deviceModule = "platform";
